import React, { useEffect, useRef, useState } from "react";
// import BuilderModal from "../../../Layouts/Modal/BuilderModal";
import axiosInstance, { handleApiError } from "../../../services/axiosService";
import { useTableContext } from "../../../context/TableContext";
import Button from "../../FormComponents/Button";
import Textarea from "../../FormComponents/Textarea";
import CustomJS from "../CustomJS";
import JobCategorySelection from "./JobCategorySelection";
import GetSelectParamsData from "./GetSelectParamsData";
import GetMultiSelectParamsData from "./GetMultiSelectParamsData";
import GetVariableMapping from "./GetVariableMapping";
import GetCheckBoxParamsData from "./GetCheckBoxParamsData";
import SingleSelectBox from "../../FormComponents/SingleSelectBox";
import PostActionJob from "./PostActionJob";
import Label from "../../FormComponents/Label";
import FieldSelectorFromPopup from "../FieldSelectorFromPopup";
import GetPrefiltersParamsData from "./GetPrefiltersParamsData";
import Input from "../../FormComponents/Input";
import { getLabelName } from "./Utils";
import { getJobIcon } from "../../../utils/getJobIcon";
import { hasOwn, mapArrayToObject } from "../../../commonFunctions/arrayFunc";
import MaterialIcon from "../MaterialIcon";
import { generateObjectId } from "../../../utils/objectIdUtils";
import { useAPIContext } from "../../../context/APIContext";
import ButtonActionIcon from "../ButtonActionIcon";
import StopJob from "../NewJobConfiguration/StopJob/StopJob";

const JobConfigration = ({
  editJob,
  smId,
  actId,
  onClick,
  templateObject,
  allJobs,
  isReadOnly = false,
  onChange,
  device,
  type = "statemachine",
  isSmJob = false,
  isJobIconAndNameOnly = false,
  onDelete
}) => {
  const [preRequirements, setPreRequirements] = useState([]);
  const { tableData, getTableTypeData } = useTableContext();
  const [selectedJob, setSelectedJob] = useState("");
  const [params, setParams] = useState({});
  const [jobTemplateName, setTemplateName] = useState("");
  const allFieldsObject = useRef({});
  const [isShowButton, setIsShowButton] = useState(false);
  const [isAllJobModalOpen, setIsAllJobModalOpen] = useState(false);
  const [editJobData, setEditJobData] = useState(null);
  const [triggerOnData, setTriggerOnData] = useState("");
  const [jobDescription, setJobDescription] = useState("");
  const [isSynchronous, setIsSynchronous] = useState(false);
  const { generateFieldObject } = useAPIContext();
  const fetchCurrentSmData = async () => {
    try {
      const { tableObject } = await getTableTypeData(type, smId);
      const dynmaicFolderObject = generateFieldObject(); // web hook api query fields data
      allFieldsObject.current = { ...allFieldsObject.current, ...tableObject, ...dynmaicFolderObject };
    } catch (error) {
      console.error("Error fetching current SM data:", error);
    }
  };
  const jobSelectionsFromEdit = useRef(false);
  const prevEditObject = useRef("");
  const isJobChange = useRef(false);

  const getTemplateData = (key) => {
    switch (key) {
      case "email_template_id":
        return templateObject["send_email"];
      case "sms_template_id":
        return templateObject["send_sms"];
      case "ocr":
        return templateObject["send_ocr"];
      case "rdbms_update":
      case "rdbms_insert":
      case "select_table":
        return templateObject["send_table"];
      case "document_template_id":
        return templateObject["send_pdf"];
      case "googledoc_template_id":
        return templateObject["send_google_doc"];
      case "exceldoc_template_id":
        return templateObject["send_excel_doc"];
      case "activity_id":
        return templateObject["send_activity_id"];
      case "activity_id_init":
        return templateObject["send_activity_id_init"];
      case "all_activity_id":
        return templateObject["send_all_activity_id"];
      case "detailsview_id":
        return templateObject["send_detailsview_id"];
      case "recordsview_id":
        return templateObject["send_recordsview_id"];
      case "where_column":
        return templateObject["send_where_column"];
      case "lookup_field_map":
        return templateObject["send_lookup_field_map"];
      case "linked_sm_lookup_id":
        return templateObject["linked_sm_lookup_id"];
      case "name":
        return templateObject["send_name"];
      case "desktop_screen":
        return templateObject["screens_device"].desktop;
      default:
        return [];
    }
  };

  const jobChangeFromSelect = (value) => {
    isJobChange.current = true;
    handleJobChange(value);
    setIsAllJobModalOpen(false);
  };
  const handleParamsData = (newParams, key, parentKey) => {
    // const parentKey = preRequirements[preRequirements.length - 1]; //variable_mapping etc
    if (key === "sub_variable_mapping") {
      const copyParams = JSON.parse(JSON.stringify(params));
      const newMapping = copyParams[parentKey].map((item) => {
        return item.key === newParams.key ? newParams : item;
      });
      setParams({ ...copyParams, [parentKey]: newMapping });
    } else {
      setParams(newParams);
    }
  };

  const handleJobChange = (value, data = allJobs) => {
    const selectedJob = data.find((job) => job.id === value);
    if (!selectedJob) return;
    setTemplateName(selectedJob.job_template);
    setPreRequirements(selectedJob.pre_requirements || []);
    // setRenderingParamsKeys([]);
    if (selectedJob.pre_requirements.length === 0) {
      setIsShowButton(true);
    }

    setSelectedJob(value);
  };

  useEffect(() => {
    if (!editJob) return;
    setEditJobData({ ...editJob });
    setTriggerOnData(editJob.trigger_on || "");
    setJobDescription(editJob.description || "");
    setIsSynchronous(editJob.is_queued || false);
  }, [editJob]);

  useEffect(() => {
    if (!editJob) {
      setIsAllJobModalOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const buildFinalConfig = () => {
    const newParams = { ...params };

    if (typeof newParams.is_a_thread === "string") {
      newParams.is_a_thread = false;
    }

    if (hasOwn(params, "variable_mapping") && params.variable_mapping) {
      const newVariableMapping = params.variable_mapping.filter(
        (mapped) =>
          mapped.value || mapped.type === "manual" || mapped.type === "self" || mapped.type === "logged_in_manager"
      );
      newParams.variable_mapping = newVariableMapping;
    }
    if (hasOwn(params, "app_user_id_mapping") && params.app_user_id_mapping) {
      const newVariableMapping = params.app_user_id_mapping.filter(
        (mapped) => mapped.value || mapped.type === "manual"
      );
      newParams.app_user_id_mapping = newVariableMapping;
    }
    if (hasOwn(params, "entity_variable_mapping") && params.entity_variable_mapping) {
      const newVariableMapping = params.entity_variable_mapping.filter(
        (mapped) =>
          mapped.value || mapped.type === "manual" || mapped.type === "self" || mapped.type === "logged_in_manager"
      );
      newParams.entity_variable_mapping = newVariableMapping;
    }
    const newId = generateObjectId();
    let config = {
      id: editJobData?.id ? editJobData.id : newId,
      job_id: selectedJob,
      job_template: jobTemplateName,
      params: newParams,
      description: jobDescription,
      is_queued: isSynchronous
    };
    if (isSmJob) {
      config = { ...config, trigger_on: triggerOnData };
    }
    if (editJobData) {
      config = { ...editJobData, ...config };
    }
    return config;
  };

  const buttonRenderCondition = (renderKeys) => {
    if (isReadOnly) return false;

    const lastKey = renderKeys[renderKeys.length - 1];
    if (selectedJob === "") return true;
    const unconditionalKeys = new Set([
      "post_job_actions",
      "is_a_thread",
      "mass_performable",
      "is_background",
      "group_ids",
      // "community_group_ids",
      "js_function",
      "navigate_with_token",
      "tablet_screen",
      "refresh_delay_time",
      "from_email_connector",
      "statechange_on_error"
    ]);

    if (unconditionalKeys.has(lastKey)) return true;

    if (jobTemplateName === "vapi_voice_ai") return true;

    if (
      (jobTemplateName === "start_state_machine" || jobTemplateName === "start_state_machine_offline") &&
      lastKey === "variable_mapping"
    ) {
      return true;
    }

    const dynamicKeys = new Set([
      "variable_mapping",
      "app_user_id_mapping",
      "sm_variable_mapping",
      "entity_variable_mapping"
    ]);

    if (renderKeys.length === preRequirements.length && params?.[lastKey]) {
      const paramValues = params[lastKey];

      if (dynamicKeys.has(lastKey)) {
        return paramValues.some(
          (v) => v.value || v.type === "manual" || v.type === "self" || v.type === "logged_in_manager"
        );
      }

      return true;
    }

    return false;
  };

  const getAppUserFieldsData = async () => {
    try {
      const { data } = await axiosInstance.get(`/userConfig`);
      let array = data.fields || [];
      array = [{ id: "target_user", field_type: "target_user" }, ...array];
      const { result: fieldObject } = mapArrayToObject(array);
      allFieldsObject.current = { ...allFieldsObject.current, ...fieldObject };
      return array;
    } catch (error) {
      return [];
    }
  };

  useEffect(() => {
    if (!smId) return;
    fetchCurrentSmData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    jobSelectionsFromEdit.current = false;
    if (!editJobData || !allJobs) return;
    handleJobChange(editJobData.job_id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editJobData, allJobs]);

  useEffect(() => {
    if (preRequirements.length === 0 || !params) return;
    const newArray = [];
    for (const index in preRequirements) {
      // eslint-disable-next-line eqeqeq
      if (index == 0) {
        newArray.push(preRequirements[index]);
        continue;
      } else if (params[preRequirements[index]]) {
        newArray.push(preRequirements[index]);
        continue;
        // eslint-disable-next-line eqeqeq
      } else if (index != 0 && params[preRequirements[index - 1]] && !params[preRequirements[index]]) {
        newArray.push(preRequirements[index]);
        continue;
      } else {
        break;
      }
    }
    // setRenderingParamsKeys(newArray);
    const buttonRender = buttonRenderCondition(newArray);
    setIsShowButton(buttonRender);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params, preRequirements]);

  useEffect(() => {
    // if (!params || !selectedJob) return;
    if (onClick || isReadOnly) return;
    const config = buildFinalConfig();
    const obj = {
      job_id: config.job_id,
      params: config.params
    };
    if (prevEditObject.current === JSON.stringify(obj)) {
      return;
    }
    prevEditObject.current = JSON.stringify(obj);
    if (typeof onChange === "function") {
      onChange(config);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params, selectedJob]);
  // if (!templateObject) return;

  const triggerOnOptions = [
    { id: "update", name: "update" },
    { id: "insert", name: "insert" },
    { id: "both", name: "both" }
  ];

  const handleDescriptionChange = (e) => {
    setJobDescription(e.target.value);
  };

  const handleChangeSync = (e) => {
    setIsSynchronous(e.target.checked);
  };

  if (isJobIconAndNameOnly) {
    const jobObj = allJobs?.find((j) => j.id === (editJob?.job_id || selectedJob));
    const jobIcon = jobObj && getJobIcon(jobObj.job_template);
    return (
      <div className="flex_column align_center justify_center">
        {jobIcon ? (
          <img
            src={jobIcon}
            alt={`${jobObj?.name ?? ""} icon`}
            style={{
              width: "50px",
              height: "50px",
              marginBottom: "12px"
            }}
          />
        ) : (
          <MaterialIcon
            name="text_fields"
            style={{
              fontSize: "36px",
              marginBottom: "12px",
              color: "#fbbf24"
            }}
          />
        )}
        <span
          style={{
            fontSize: "16px",
            color: "#444",
            textAlign: "center",
            marginTop: "6px"
          }}
        >
          {jobObj?.name ?? ""}
        </span>
      </div>
    );
  }

  const showRunSync = jobTemplateName === "execute_pro_code" || jobTemplateName === "custom_js";
  return (
    <div className="builder_form_container">
      <div className="builder_form_scrollable">
        {isAllJobModalOpen ? (
          <div className="position_relative">
            {selectedJob && (
              <MaterialIcon
                name="arrow_back"
                className="cursor_pointer position_absolute"
                onClick={() => {
                  setIsAllJobModalOpen(false);
                }}
                style={{ right: "44px", top: "8px" }}
              />
            )}
            <JobCategorySelection allJobs={allJobs} selectJob={jobChangeFromSelect} />
          </div>
        ) : (
          <>
            {isReadOnly ? (
              <div className="flex_column gap_2">
                {allJobs.length > 0 &&
                  allJobs.map((job) => {
                    if (job.id === selectedJob) {
                      return (
                        <div
                          className="post_activity_value d_flex"
                          key={job.id + job.name}
                          style={{ alignItems: "center" }}
                        >
                          <div>
                            {getJobIcon(job.job_template) ? (
                              <img
                                src={getJobIcon(job.job_template)}
                                alt={`${job.name} Icon`}
                                style={{
                                  width: "50px",
                                  height: "50px",
                                  marginRight: "5px",
                                  verticalAlign: "middle"
                                }}
                              />
                            ) : (
                              <MaterialIcon
                                name="text_fields"
                                style={{
                                  marginRight: "8px",
                                  width: "30px",
                                  height: "30px",
                                  verticalAlign: "middle"
                                }}
                              />
                            )}
                          </div>
                          {job.name}
                        </div>
                      );
                    }
                    return null;
                  })}
                {isSmJob && (
                  <div className="d_flex">
                    <div className="post_activity_key">Trigger on :&nbsp;</div>
                    <div className="post_activity_value">{triggerOnData || ""}</div>
                  </div>
                )}
                <div className="d_flex">
                  <div className="post_activity_key">Description :&nbsp;</div>
                  <div>{jobDescription || ""}</div>
                </div>
                {showRunSync && (
                  <div className="d_flex">
                    <div className="post_activity_key">Run Synchronously :&nbsp;</div>
                    <div>{isSynchronous ? "Yes" : "No"}</div>
                  </div>
                )}
              </div>
            ) : (
              <div className="builder_form">
                <div className="form_element_wrapper_text">
                  <span className="builder_label">Job Name</span>
                  <div className="inline_tag_items">
                    {selectedJob !== "" && (
                      <div className="builder_displayBox justify_start">
                        <span className="builder_bold_text">{allJobs.find((j) => j.id === selectedJob).name}</span>
                      </div>
                    )}

                    {!editJob && selectedJob && (
                      <Button variant="secondary" onClick={() => setIsAllJobModalOpen(true)}>
                        Change
                      </Button>
                    )}
                  </div>
                </div>

                <Textarea
                  label="Job Description"
                  value={jobDescription}
                  onChange={handleDescriptionChange}
                  placeholder="Enter job description"
                  className="builder_textarea"
                />

                {showRunSync && (
                  <Input
                    type="checkbox"
                    label="Run Synchronously"
                    checked={isSynchronous}
                    onChange={handleChangeSync}
                    className="builder_textarea"
                  />
                )}

                {isSmJob && selectedJob !== "" && (
                  <>
                    <span className="builder_label">Trigger On</span>
                    <div className="inline_tag_items">
                      <SingleSelectBox
                        options={triggerOnOptions}
                        selectedData={triggerOnData}
                        onChange={(selectedOption) => setTriggerOnData(selectedOption.id)}
                        placeholder={`Select `}
                      />
                    </div>
                  </>
                )}
              </div>
            )}
            {selectedJob &&
              preRequirements.length > 0 &&
              preRequirements.map((key, index) => {
                let shouldRender = index === 0 || params[preRequirements[index - 1]];
                if (jobTemplateName === "vapi_voice_ai") {
                  shouldRender = true;
                }
                if (!shouldRender && preRequirements[index - 1] === "tablet_screen") {
                  shouldRender = true;
                }
                if (!shouldRender && preRequirements[index - 1] === "from_email_connector") {
                  shouldRender = true;
                }
                return shouldRender ? (
                  <React.Fragment key={key}>
                    <SinglePreRequirement
                      keyName={key}
                      smId={smId}
                      params={params}
                      setParams={setParams}
                      handleParamsData={handleParamsData}
                      isReadOnly={isReadOnly}
                      preRequirements={preRequirements}
                      tableData={tableData}
                      allFieldsObject={allFieldsObject}
                      templateObject={templateObject}
                      device={device}
                      editJobData={editJobData}
                      getTemplateData={getTemplateData}
                      jobTemplateName={jobTemplateName}
                      getAppUserFieldsData={getAppUserFieldsData}
                      actId={actId}
                      setEditJobData={setEditJobData}
                      type={type}
                      allJobs={allJobs}
                    />
                  </React.Fragment>
                ) : null;
              })}
          </>
        )}
      </div>
      {/* Sticky Save Button */}
      <div className="builder_form_sticky_footer">
        <div className="d_flex gap_3 justify_end">
          {onDelete && (
            <Button variant="delete" onClick={onDelete}>
              Delete
            </Button>
          )}

          {isShowButton && onClick && <Button onClick={() => onClick(buildFinalConfig())}>Save</Button>}
        </div>
      </div>
    </div>
  );
};

const SinglePreRequirement = ({
  keyName,
  params,
  setParams,
  handleParamsData,
  isReadOnly,
  preRequirements,
  smId,
  tableData,
  allFieldsObject,
  templateObject,
  device,
  editJobData,
  getTemplateData,
  jobTemplateName,
  getAppUserFieldsData,
  actId,
  setEditJobData,
  type,
  allJobs
}) => {
  const getSelectParams = () => {
    return (
      <GetSelectParamsData
        keyName={keyName}
        smId={smId}
        params={params}
        isReadOnly={isReadOnly}
        tableData={tableData}
        templateObject={templateObject}
        device={device}
        editJobData={editJobData}
        setParams={setParams}
        preRequirements={preRequirements}
        allFieldsObject={allFieldsObject}
        setEditJobData={setEditJobData}
        actId={actId}
        type={type}
        jobTemplateName={jobTemplateName}
      />
    );
  };
  const getPrefiltersParams = () => {
    return (
      <GetPrefiltersParamsData
        keyName={keyName}
        smId={smId}
        params={params}
        isReadOnly={isReadOnly}
        tableData={tableData}
        templateObject={templateObject}
        device={device}
        editJobData={editJobData}
        setParams={setParams}
        preRequirements={preRequirements}
        allFieldsObject={allFieldsObject}
        setEditJobData={setEditJobData}
        actId={actId}
        type={type}
        jobTemplateName={jobTemplateName}
      />
    );
  };
  const getCheckBoxParams = () => {
    return (
      <GetCheckBoxParamsData
        keyName={keyName}
        params={params}
        isReadOnly={isReadOnly}
        tableData={tableData}
        editJobData={editJobData}
        setParams={setParams}
        preRequirements={preRequirements}
        setEditJobData={setEditJobData}
        type={type}
      />
    );
  };
  const getMultiSelectParams = () => {
    return (
      <GetMultiSelectParamsData
        keyName={keyName}
        // onChange={multiParamsSelector}
        smId={smId}
        params={params}
        isReadOnly={isReadOnly}
        tableData={tableData}
        templateObject={templateObject}
        device={device}
        editJobData={editJobData}
        preRequirements={preRequirements}
        allFieldsObject={allFieldsObject}
        setParams={setParams}
        setEditJobData={setEditJobData}
        type={type}
      />
    );
  };
  const getPostJobActions = () => {
    return (
      <GetPostJobActions
        keyName={keyName}
        params={params}
        setParams={setParams}
        smId={smId}
        device={device}
        templateObject={templateObject}
        jobTemplateName={jobTemplateName}
        actId={actId}
        type={type}
        editJobData={editJobData}
        isReadOnly={isReadOnly}
        allJobs={allJobs}
      />
    );
  };
  const getVariableMapping = () => {
    return (
      <GetVariableMapping
        keyName={keyName}
        params={params}
        setParams={setParams}
        handleParamsData={handleParamsData}
        smId={smId}
        allFieldsObject={allFieldsObject}
        isReadOnly={isReadOnly}
        device={device}
        templateObject={templateObject}
        editJobData={editJobData}
        getTemplateData={getTemplateData}
        jobTemplateName={jobTemplateName}
        getAppUserFieldsData={getAppUserFieldsData}
        preRequirements={preRequirements}
        actId={actId}
        type={type}
      />
    );
  };
  switch (keyName) {
    case "sm_id":
    case "entity_id":
    case "detailsview_id":
    case "recordsview_id":
    case "activity_id":
    case "activity_id_init":
    case "all_activity_id":
    case "lookup_field_map":
    case "select_table":
    case "where_column":
    case "email_template_id":
    case "sms_template_id":
    case "document_template_id":
    case "googledoc_template_id":
    case "exceldoc_template_id":
    case "name":
    case "system_activity_id":
    case "light_lookup":
    case "linked_sm_lookup_id":
    case "desktop_screen":
    case "mobile_screen":
    case "tablet_screen":
    case "mongo_template":
    case "pro_code_id":
    case "gateway":
    case "grid_id":
    case "ocr_template_id":
    case "frequency":
    case "rdbms_form_id":
    case "http_template_id":
    case "db_connector":
    case "from_email_connector":
    case "statechange_on_error":
      return getSelectParams();
    case "condition_mapping":
      return (
        <StopJob
          preRequirements={preRequirements}
          params={params}
          setParams={setParams}
          tableId={smId}
          tableType={type}
          readOnly={isReadOnly}
          editJobData={editJobData}
          keyName={keyName}
        />
      );

    case "navigate_with_token":
    case "is_a_thread":
    case "mass_performable":
    case "is_background":
      return getCheckBoxParams();

    case "pre_filter":
      return getPrefiltersParams();

    case "doc_template_ids":
    case "group_ids":
      // case "community_group_ids":
      return getMultiSelectParams();

    case "post_job_actions":
      return getPostJobActions();
    case "statechange_on_value":
      return (
        <StateOnChangeValue
          keyName={keyName}
          params={params}
          setParams={setParams}
          editJobData={editJobData}
          preRequirements={preRequirements}
          smId={smId}
          allFieldsObject={allFieldsObject}
          isReadOnly={isReadOnly}
        />
      );

    case "variable_mapping":
    case "app_user_id_mapping":
    case "prefill_mapping":
    case "sm_variable_mapping":
    case "entity_variable_mapping":
    case "entity_global_variable_mapping":
    case "parent_sm_variable_mapping":
    case "query_variable_mapping":
    case "body_variable_mapping":
    case "header_variable_mapping":
    case "url_variable_mapping":
    case "output_variable_mapping":
    case "set_global_variable_mapping":
    case "self_global_variable_mapping":
    case "grid_json_variable_mapping":
      return getVariableMapping();
    case "navigate_variable_mapping":
    case "assistant_override_variables":
    case "json_grid_variable_mapping":
      const addNavigateMapping = () => {
        const mappedArr = params[keyName] || [];
        const obj = {
          ...params,
          [keyName]: [...mappedArr, { key: "", value: "", type: "mapped" }]
        };
        setParams(obj);
      };
      return (
        <div>
          {!isReadOnly && (
            <div onClick={addNavigateMapping} className="builder_btn_secondary w_fit ml_auto ">
              + Add
            </div>
          )}
          {getVariableMapping()}
        </div>
      );
    case "js_function":
    case "query":
      return (
        <CustomFunctionTextareaParams
          label="Custom JS"
          isReadOnly={isReadOnly}
          editJobData={editJobData}
          params={params}
          setParams={setParams}
          smId={smId}
          keyName={keyName}
        />
      );
    case "customer_phone_number":
    case "customer_name":
    case "vapi_phone_number":
    case "vapi_assistant_id":
    case "json_path":
    case "output_variable":
    case "screen_name":
      return (
        <TextFieldParams
          isReadOnly={isReadOnly}
          editJobData={editJobData}
          params={params}
          setParams={setParams}
          keyName={keyName}
          preRequirements={preRequirements}
          setEditJobData={setEditJobData}
        />
      );
    case "refresh_delay_time":
      return (
        <NumberFieldParams
          isReadOnly={isReadOnly}
          editJobData={editJobData}
          params={params}
          setParams={setParams}
          keyName={keyName}
          preRequirements={preRequirements}
          setEditJobData={setEditJobData}
        />
      );
    case "user_id":
    case "grid_path":
    case "json_output_variable":
      return (
        <SingleFieldSelectFromTable
          keyName={keyName}
          params={params}
          setParams={setParams}
          editJobData={editJobData}
          preRequirements={preRequirements}
          smId={smId}
          allFieldsObject={allFieldsObject}
        />
      );

    default:
      break;
  }
};

const TextFieldParams = ({ keyName, isReadOnly, params, setParams, editJobData, preRequirements, setEditJobData }) => {
  useEffect(() => {
    if (editJobData) {
      setParams({ ...params, [keyName]: editJobData.params[keyName] });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params[preRequirements[preRequirements.indexOf(keyName) - 1]]]);
  return (
    <div className="">
      <Label>{getLabelName(keyName)}</Label>
      {isReadOnly ? (
        <div>{params[keyName]}</div>
      ) : (
        <Input
          className="post_activity_value"
          value={params[keyName]}
          onChange={(e) => {
            const newParams = { ...params };
            newParams[keyName] = e.target.value;
            setParams(newParams);
            setEditJobData(null);
          }}
        />
      )}
    </div>
  );
};

const NumberFieldParams = ({
  keyName,
  isReadOnly,
  params,
  setParams,
  editJobData,
  preRequirements,
  setEditJobData
}) => {
  useEffect(() => {
    if (editJobData) {
      setParams({ ...params, [keyName]: editJobData.params[keyName] });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params[preRequirements[preRequirements.indexOf(keyName) - 1]]]);

  return (
    <div className="">
      <Label>{getLabelName(keyName)}</Label>
      {isReadOnly ? (
        <div>{params[keyName]}</div>
      ) : (
        <Input
          className="post_activity_value"
          type="number"
          value={params[keyName] ?? ""}
          onChange={(e) => {
            const newParams = { ...params };
            const numberValue = e.target.value === "" ? "" : parseFloat(e.target.value);
            newParams[keyName] = isNaN(numberValue) ? "" : numberValue;
            setParams(newParams);
            setEditJobData(null);
          }}
        />
      )}
    </div>
  );
};

const CustomFunctionTextareaParams = ({ label, isReadOnly, keyName, params, setParams, editJobData, smId }) => {
  const [flag, setFlag] = useState(false);

  useEffect(() => {
    if (editJobData) {
      setParams({ ...editJobData.params });
    }
    setFlag(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isReadOnly) {
    return (
      <div className="d_flex">
        <div className="post_activity_key mr_1">{label} :&nbsp;</div>
        {params[keyName] ? (
          <Textarea
            // label={${label} :}
            // className="post_activity_value"
            value={params[keyName]}
            disabled
          />
        ) : (
          "NONE"
        )}
      </div>
    );
  }
  if (!flag) return null;

  return (
    <>
      <div style={{ minHeight: "200px" }}>
        <CustomJS
          height="300px"
          inputString={params[keyName] || ""}
          handleChange={(data) => setParams({ ...params, [keyName]: data })}
          tableID={smId}
        />
      </div>
    </>
  );
};
const GetPostJobActions = ({
  keyName,
  params,
  jobTemplateName,
  setParams,
  smId,
  device,
  type,
  templateObject,
  allJobs,
  editJobData,
  isReadOnly
}) => {
  let defaultData = {};

  switch (jobTemplateName) {
    default:
      break;
  }

  const onChangePostjobActions = (newPostJobData) => {
    setParams({ ...params, [keyName]: newPostJobData });
  };
  useEffect(() => {
    const fetchData = async () => {
      if (editJobData) {
        setParams({ ...params, [keyName]: editJobData.params[keyName] });
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (isReadOnly) {
    let jobData = params[keyName] || defaultData;
    return (
      <div className="d_flex flex_column gap_2">
        {Object.keys(jobData).map((key) => {
          const jobsArray = jobData[key];
          return (
            <div className="job-section p_3" key={key}>
              <Label>{key.split("_").join(" ")}</Label>
              <ul>
                {jobsArray.map((jobId) => (
                  <li key={jobId.id} className="ml_3">
                    {jobId.job_template.split("_").join(" ")}
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
      </div>
    );
  }
  return (
    <div>
      <Label>{keyName.split("_").join(" ")}</Label>
      <PostActionJob
        postJobData={params[keyName] || defaultData}
        onChange={onChangePostjobActions}
        smId={smId}
        device={device}
        type={type}
        templateObject={templateObject}
        allJobs={allJobs}
      />
    </div>
  );
};

const SingleFieldSelectFromTable = ({ keyName, params, setParams, editJobData, preRequirements, smId }) => {
  useEffect(() => {
    if (editJobData) {
      setParams({ ...params, [keyName]: editJobData.params[keyName] });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params[preRequirements[preRequirements.indexOf(keyName) - 1]]]);

  const getLabel = () => {
    switch (keyName) {
      case "user_id":
        return "User ID";
      case "json_output_variable":
        return "JSON Output Variable";
      case "grid_path":
        return "Grid Variable";
      default:
        return getLabelName(keyName);
    }
  };

  return (
    <>
      <label className="builder_label">{getLabel()}</label>
      <FieldSelectorFromPopup
        tableId={smId}
        tableType="statemachine"
        onSelect={(fieldObj) => setParams({ ...params, [keyName]: fieldObj?.id })}
        fieldId={params?.[keyName]}
        id={keyName}
      />
    </>
  );
};

function LogicBuilder({ value = [], onChange, states = [], isReadOnly = false }) {
  const [newFieldId, setNewFieldId] = useState("");

  const handleAddField = () => {
    if (!newFieldId.trim()) return;
    const updated = [...value, { field_id: newFieldId, logic_data: [{ operator: "==", state_id: "", value: "" }] }];
    onChange(updated);
    setNewFieldId("");
  };

  const handleRemoveField = (fieldId) => {
    const updated = value.filter((field) => field.field_id !== fieldId);
    onChange(updated);
  };

  const handleAddLogic = (fieldId) => {
    const updated = value.map((field) =>
      field.field_id === fieldId
        ? {
            ...field,
            logic_data: [...field.logic_data, { operator: "==", state_id: "", value: "" }]
          }
        : field
    );
    onChange(updated);
  };

  const handleRemoveLogic = (fieldId, index) => {
    const updated = value.map((field) =>
      field.field_id === fieldId
        ? {
            ...field,
            logic_data: field.logic_data.filter((_, i) => i !== index)
          }
        : field
    );
    onChange(updated);
  };

  const handleStateChange = (fieldId, index, selectedOption) => {
    const updated = value.map((field) =>
      field.field_id === fieldId
        ? {
            ...field,
            logic_data: field.logic_data.map((logic, i) =>
              i === index ? { ...logic, state_id: selectedOption?.id || "" } : logic
            )
          }
        : field
    );
    onChange(updated);
  };

  const handleValueChange = (fieldId, index, newValue) => {
    const updated = value.map((field) =>
      field.field_id === fieldId
        ? {
            ...field,
            logic_data: field.logic_data.map((logic, i) => (i === index ? { ...logic, value: newValue } : logic))
          }
        : field
    );
    onChange(updated);
  };

  const handleOperatorChange = (fieldId, index, newOperator) => {
    const updated = value.map((field) =>
      field.field_id === fieldId
        ? {
            ...field,
            logic_data: field.logic_data.map((logic, i) =>
              i === index
                ? {
                    ...logic,
                    operator: newOperator,
                    value: newOperator === "empty" ? "" : logic.value
                  }
                : logic
            )
          }
        : field
    );
    onChange(updated);
  };

  const operatorOptions = [
    { id: "empty", name: "Is Empty" },
    { id: "equals_ignore_case", name: "Equals (Ignore Case)" },
    { id: "contains_str", name: "Contains" },
    { id: "contains_str_ignore_case", name: "Contains (Ignore Case)" },
    { id: "==", name: "Equals" },
    { id: "!=", name: "Not Equals" }
  ];

  if (isReadOnly) {
    return (
      <div style={{ marginTop: "1rem" }}>
        <h4 className="mb_2">State On Change Value</h4>
        {value.length === 0 ? (
          <p style={{ color: "#888" }}>No logic configured</p>
        ) : (
          value.map((field) => (
            <table
              key={field.field_id}
              style={{
                width: "100%",
                borderCollapse: "collapse",
                marginBottom: "1rem"
              }}
            >
              <thead>
                <tr>
                  <th
                    colSpan="3"
                    style={{
                      textAlign: "left",
                      background: "#f5f5f5",
                      padding: "8px",
                      border: "1px solid #ddd"
                    }}
                  >
                    Field: {field.field_id}
                  </th>
                </tr>
                <tr>
                  <th style={{ border: "1px solid #ddd", padding: "6px" }}>Operator</th>
                  <th style={{ border: "1px solid #ddd", padding: "6px" }}>Value</th>
                  <th style={{ border: "1px solid #ddd", padding: "6px" }}>State</th>
                </tr>
              </thead>
              <tbody>
                {field.logic_data.map((logic, i) => {
                  const matchedState = states.find((s) => s.id === logic.state_id);
                  return (
                    <tr key={i}>
                      <td style={{ border: "1px solid #ddd", padding: "6px" }}>
                        {operatorOptions.find((op) => op.id === logic.operator)?.name || logic.operator || "-"}
                      </td>
                      <td style={{ border: "1px solid #ddd", padding: "6px" }}>{logic.value || "-"}</td>
                      <td style={{ border: "1px solid #ddd", padding: "6px" }}>
                        {matchedState ? matchedState.name : logic.state_id || "-"}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ))
        )}
      </div>
    );
  }

  return (
    <div>
      {/* Add New Field Section */}
      <div
        style={{
          display: "flex",
          gap: "8px",
          marginBottom: "16px",
          alignItems: "center"
        }}
      >
        <Input
          type="text"
          placeholder="Enter the value path. Ex: info.error"
          value={newFieldId}
          onChange={(e) => setNewFieldId(e.target.value)}
        />
        <Button onClick={handleAddField} variant="secondary">
          + Add Path
        </Button>
      </div>

      {/* Field Logic Groups */}
      {value.map((field) => (
        <div
          key={field.field_id}
          style={{
            border: "1px solid #ddd",
            borderRadius: "4px",
            padding: "8px",
            marginBottom: "12px"
          }}
        >
          {/* Field Header */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "10px"
            }}
          >
            <span style={{ fontWeight: "bold" }}>Field: {field.field_id}</span>
            <div className="d_flex justify_between gap_2">
              <ButtonActionIcon onClick={() => handleRemoveField(field.field_id)} type="delete" />
              <ButtonActionIcon onClick={() => handleAddLogic(field.field_id)} type="add" />
            </div>
          </div>

          {/* Logic Rows */}
          {field.logic_data.map((logic, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                marginBottom: "8px"
              }}
            >
              {/* Operator select */}
              <div style={{ flex: 1 }}>
                <div style={{ flex: 1 }}>
                  <SingleSelectBox
                    options={operatorOptions}
                    valueKey="id"
                    labelKey="name"
                    selectedData={logic.operator}
                    onChange={(selected) => handleOperatorChange(field.field_id, index, selected?.id || "")}
                    placeholder="Select operator..."
                    isSearch={false}
                  />
                </div>
              </div>

              {/* Value input */}
              <div style={{ flex: 1 }}>
                <Input
                  type="text"
                  placeholder="Enter value..."
                  value={logic.value || ""}
                  onChange={(e) => handleValueChange(field.field_id, index, e.target.value)}
                  disabled={logic.operator === "empty"}
                />
              </div>

              {/* State selector */}
              <div style={{ flex: 1 }}>
                <SingleSelectBox
                  options={states}
                  valueKey="id"
                  labelKey="name"
                  selectedData={logic.state_id}
                  onChange={(selected) => handleStateChange(field.field_id, index, selected)}
                  placeholder="Select a state..."
                  isSearch={true}
                />
              </div>

              <ButtonActionIcon onClick={() => handleRemoveLogic(field.field_id, index)} type="delete" />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

function StateOnChangeValue({ keyName, params, setParams, editJobData, preRequirements, smId, isReadOnly }) {
  const [rules, setRules] = useState([]);
  const [states, setStates] = useState([]);

  useEffect(() => {
    const getStateData = async () => {
      try {
        const { data: states } = await axiosInstance.get(`/state-machine/${smId}/states`);
        setStates(states);
      } catch (err) {
        handleApiError(err);
      }
    };
    getStateData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (editJobData?.params?.[keyName]) {
      setRules(editJobData.params[keyName]);
      setParams((prev) => ({
        ...prev,
        [keyName]: editJobData.params[keyName]
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params[preRequirements[preRequirements.indexOf(keyName) - 1]]]);

  const handleChange = (newRules) => {
    setRules(newRules);
    setParams((prev) => ({
      ...prev,
      [keyName]: newRules
    }));
  };

  return (
    <div className="builder_form">
      <label className="builder_label">State Change on Value</label>
      <LogicBuilder value={rules} onChange={handleChange} states={states} isReadOnly={isReadOnly} />
    </div>
  );
}

export default JobConfigration;
